<template>
  <!-- Dispatcher minimal: según tipo de usuario muestra Admin o Casos -->
  <div id="app">
    <component :is="myComponent" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import api from './services/api.js'
import Admin from './views/Admin.vue'
import Translator from './views/Translator.vue'

const currentUser = ref(null)
const loadingUser = ref(true)

// Normalizar tipo de usuario: soportar `type` (antiguo) o `role` (server)
const userType = computed(() => {
  const u = currentUser.value
  if (!u) return null
  const raw = u.type || u.role || u.userType || u.roleName || null
  return raw ? String(raw).toLowerCase() : null
})

const Unauthorized = {
  template: '<div style="padding:20px;">Acceso no autorizado para tu tipo de usuario.</div>'
}

onMounted(async () => {
  try {
    // Intentar verificar la sesión en el servidor y usar el usuario verificado
    const data = await api.verify()
    currentUser.value = data?.user || api.getCurrentUser()
  } catch (e) {
    // Fallback a localStorage si verify falla
    currentUser.value = api.getCurrentUser()
  } finally {
    loadingUser.value = false
  }
})

const myComponent = computed(() => {
  console.log('userType:', userType.value);
  switch (userType.value) {
    case 'translator':
      return Translator
    case 'admin':
    default:
      return Admin
  }
})
</script>
